import { Divider, Shape, styled } from '@teko/ds-mobile';
import { BlockHeader, BlockHeaderProps } from '@teko/teko-ecommerce';
import { useProductDetailState, useTenantConfig } from 'contexts';
import { t } from 'i18n';
import React from 'react';
import { ProductRatingList } from '../../desktop/DetailPageSGC/ProductRating';
import { RatingOverview } from './RatingOverview';

export const ReviewSection: React.FC = () => {
  const { productRatingData } = useProductDetailState();
  const { epicOmni1550HideReviewButton } = useTenantConfig();

  // Hide review section when this config on & no rating data
  if (epicOmni1550HideReviewButton && !productRatingData.data?.reviews.length)
    return null;

  return (
    <Shape
      id="review-section"
      backgroundColor="white"
      borderRadius="xl"
      padding="s8"
      margin={['s8', 's0']}
    >
      <StyledBlockHeader title={t('Đánh giá')} />

      <RatingOverview ratingData={productRatingData} />
      <Divider color="divider" gap="16px" />
      {!!productRatingData.totalReviews && (
        <ProductRatingList ratingData={productRatingData} />
      )}
    </Shape>
  );
};

const StyledBlockHeader = styled(BlockHeader)<BlockHeaderProps>`
  border-bottom: 1px solid #ebeaea;
`;
